import { trackWithGoogleAnalytics } from '../shared/trackers/trackWithGoogleAnalytics';
import { adaptItemToRequest } from './adapters/adaptItemToRequest';
import { IItem } from './models/IItem';

interface ISetCheckoutOptionEvent {
	isNewCard: boolean;
	cardType: string;
	items: IItem[];
}

/**
 * https://developers.google.com/analytics/devguides/collection/gtagjs/enhanced-ecommerce#2_measure_checkout_options
 */
export function trackSetCheckoutOption({
	isNewCard,
	cardType,
	items,
}: ISetCheckoutOptionEvent) {
	trackWithGoogleAnalytics('event', 'set_checkout_option', {
		checkout_option: isNewCard ? 'added_new_card' : 'selected_existing_card',
		value: cardType,
		items: items.map(adaptItemToRequest),
	});
}
